import { Match } from "model/Match/Match";
import { CompactMatchListItem } from "./CompactMatchListItem";
import { selectTournamentIdFromMatchId } from "selectors/Match";
import { arrayCompareWithShallowEquals, nonUndefined } from "Utility";
import { useAppSelector } from "app/hooks";
import { PanelList } from "components/PanelList/PanelList";

interface Props {
  matches: Match[];
  ascending: boolean;
  hoverColor?: string;
}

export const CompactMatchList = ({ matches, ascending, hoverColor }: Props) => {
  const sortedMatches = matches.sort((a, b) =>
    ascending ? a.startTimeMs - b.startTimeMs : b.startTimeMs - a.startTimeMs
  );

  const matchesWithTournamentId = useAppSelector(
    (state) =>
      nonUndefined(
        sortedMatches.map((match) => {
          const tournamentId = selectTournamentIdFromMatchId(state, match.id);
          if (!tournamentId) {
            return undefined;
          }

          return { match, tournamentId };
        })
      ),
    arrayCompareWithShallowEquals
  );
  return (
    <PanelList hoverColor={hoverColor}>
      {matchesWithTournamentId.map(({ match, tournamentId }) => (
        <CompactMatchListItem
          key={match.id}
          match={match}
          tournamentId={tournamentId}
        />
      ))}
    </PanelList>
  );
};
